<template>
  <div class="homePage">
    <Header :type="pageType" />
    <div class="main_page">
      <div class="home_banner">
        <div class="banner_text">
          为普通人定制科学保障，专家在线1对1一站式终身服务
        </div>
        <div class="banner_qrcode">
          <img src="@/assets/images/versionNew/qrcode_new.jpg" alt="" />
        </div>
      </div>
      <div class="tags">
        <div class="tag_item">
          <img src="@/assets/images/version/tag1.png" alt="" />
          <div class="tag_title">
            经银保监会批准成立的保险经纪公司
          </div>
        </div>
        <div class="tag_item">
          <img src="@/assets/images/version/tag2.png" alt="" />
          <div class="tag_title">对接1000+款保险产品</div>
        </div>
        <div class="tag_item">
          <img src="@/assets/images/version/tag3.png" alt="" />
          <div class="tag_title">致力于服务数百万家庭</div>
        </div>
        <div class="tag_item">
          <img src="@/assets/images/version/tag4.png" alt="" />
          <div class="tag_title">至少节省30-50%保费</div>
        </div>
      </div>
      <div class="news">
        <div class="news_item" v-for="(item, index) in news" :key="index">
          <div class="news_title">
            {{ item.title }}
          </div>
          <div class="news_content">
            {{ item.content }}
          </div>
        </div>
      </div>
      <div class="bx_container" style="padding-top:70px;">
        <div class="bx_container_title">
          <h1 class="main_title">骆驼规划</h1>
          <div class="sub_title">专业中立</div>
        </div>
        <div class="bx_container_content">
          <div class="services">
            <div class="service_item">
              <img src="@/assets/images/version/service1.png" alt="保险科普" />
              <div class="service_title">
                <div class="main">保险科普</div>
                <div class="sub">专业化顾问团队<br />教你买保险不踩坑</div>
              </div>
            </div>
            <div class="service_item">
              <img src="@/assets/images/version/service2.png" alt="风险评测" />
              <div class="service_title">
                <div class="main">风险评测</div>
                <div class="sub">了解家庭基本情况<br />评估未来潜在风险</div>
              </div>
            </div>
            <div class="service_item">
              <img src="@/assets/images/version/service3.png" alt="方案定制" />
              <div class="service_title">
                <div class="main">方案定制</div>
                <div class="sub">1对1专属定制方案<br />至少节省30-50%保费</div>
              </div>
            </div>
            <div class="service_item">
              <img src="@/assets/images/version/service4.png" alt="理赔协助" />
              <div class="service_title">
                <div class="main">理赔协助</div>
                <div class="sub">终身理赔协助<br />一站式省心服务</div>
              </div>
            </div>
          </div>
          <v-popover
            class="my_popover"
            popoverClass="vue-popover-home"
            offset="16"
            trigger="click"
            placement="bottom"
          >
            <div class="home_btn" @click="point('了解服务')">
              了解服务 <i class="arrow_right" />
            </div>
            <template slot="popover">
              <img
                src="@/assets/images/versionNew/qrcode_new.jpg"
                alt="骆驼讲保微信公众号二维码"
              />
              <div class="popover_text">骆驼讲保微信公众号</div>
            </template>
          </v-popover>
        </div>
      </div>
      <div
        class="bx_container advantage_bx_container"
        style="padding-top:110px;"
      >
        <div class="bx_container_title">
          <div class="main_title">我们的优势</div>
          <div class="sub_title">量身定制的保障规划服务</div>
        </div>
        <div class="bx_container_content">
          <div class="advantages">
            <div class="advantage_item">
              <img
                src="@/assets/images/version/advantage1.png"
                alt="用户视角"
              />
              <div class="advantage_title">
                <div class="main">用户视角</div>
                <div class="sub">
                  客观中立，基于用户的立场挑选合适的产品，至少节省30-50%的保费
                </div>
              </div>
            </div>
            <div class="advantage_item">
              <img
                src="@/assets/images/version/advantage2.png"
                alt="科学量化"
              />
              <div class="advantage_title">
                <div class="main">科学量化</div>
                <div class="sub">
                  依托大数据、云计算技术，帮助用户实现家庭风险量化、精准产品匹配
                </div>
              </div>
            </div>
            <div class="advantage_item">
              <img
                src="@/assets/images/version/advantage3.png"
                alt="专业省心"
              />
              <div class="advantage_title">
                <div class="main">专业省心</div>
                <div class="sub">
                  通过精算、核保、理赔、法律等提供全流程专业服务，为用户提供终身服务
                </div>
              </div>
            </div>
            <div class="advantage_item">
              <img
                src="@/assets/images/version/advantage4.png"
                alt="持牌机构"
              />
              <div class="advantage_title">
                <div class="main">持牌机构</div>
                <div class="sub">
                  拥有银保监会颁发的经营保险经纪业务许可证
                </div>
              </div>
            </div>
          </div>
          <v-popover
            class="my_popover"
            popoverClass="vue-popover-home"
            offset="16"
            trigger="click"
            placement="bottom"
          >
            <div class="home_btn mt" @click="point('对比优势')">
              对比优势 <i class="arrow_right" />
            </div>
            <template slot="popover">
              <img
                src="@/assets/images/versionNew/qrcode_new.jpg"
                alt="骆驼讲保微信公众号二维码"
              />
              <div class="popover_text">骆驼讲保微信公众号</div>
            </template>
          </v-popover>
        </div>
      </div>
      <div class="bx_container" style="padding-top:110px;">
        <div class="bx_container_title">
          <div class="main_title">规划对比</div>
          <div class="sub_title">至少节省30-50%保费</div>
        </div>
        <div class="bx_container_content">
          <solution-table />
          <v-popover
            class="my_popover"
            popoverClass="vue-popover-home"
            offset="16"
            trigger="click"
            placement="bottom"
          >
            <div class="home_btn" @click="point('定制方案')">
              定制方案 <i class="arrow_right" />
            </div>
            <template slot="popover">
              <img
                src="@/assets/images/versionNew/qrcode_new.jpg"
                alt="骆驼讲保微信公众号二维码"
              />
              <div class="popover_text">骆驼讲保微信公众号</div>
            </template>
          </v-popover>
        </div>
      </div>
      <div class="bx_container" style="padding-top:0">
        <div class="bx_container_title">
          <div class="main_title">顾问资质</div>
          <div class="sub_title">严格筛选 传递专业价值</div>
        </div>
        <div class="bx_container_content">
          <div class="qualifications">
            <div class="qualification_item">
              <img
                src="@/assets/images/version/qualification1.png"
                alt="专家团队"
              />
              <div class="qualification_title">
                <div class="main">专家团队</div>
                <div class="sub">
                  所有咨询专家拥有多年行业经验，具备保险、金融、经济等专业背景
                </div>
              </div>
            </div>
            <div class="qualification_item">
              <img
                src="@/assets/images/version/qualification2.png"
                alt="资质认证"
              />
              <div class="qualification_title">
                <div class="main">资质认证</div>
                <div class="sub">
                  100%银保监会注册登记，拥有丰富家庭保险规划咨询经验
                </div>
              </div>
            </div>
            <div class="qualification_item">
              <img
                src="@/assets/images/version/qualification3.png"
                alt="考核机制"
              />
              <div class="qualification_title">
                <div class="main">考核机制</div>
                <div class="sub">
                  基于平台多维考核体系，全流程管控顾问质量
                </div>
              </div>
            </div>
          </div>
          <v-popover
            class="my_popover"
            popoverClass="vue-popover-home"
            offset="16"
            trigger="click"
            placement="bottom"
          >
            <div class="home_btn" @click="point('了解顾问')">
              了解顾问 <i class="arrow_right" />
            </div>
            <template slot="popover">
              <img
                src="@/assets/images/versionNew/qrcode_new.jpg"
                alt="骆驼讲保微信公众号二维码"
              />
              <div class="popover_text">骆驼讲保微信公众号</div>
            </template>
          </v-popover>
        </div>
      </div>
      <div class="bx_container_orange">
        <div class="orange_title">
          <div class="main">
            用户评价
          </div>
          <div class="sub">
            被用户信赖的第三方平台
          </div>
        </div>
        <div class="orange_container">
          <div class="orange_item">
            <img
              class="user_avatar"
              src="@/assets/images/version/comment1.png"
              alt=""
            />
            <div class="user_info">28岁的新手宝妈</div>
            <div class="main_title">一家三口 省了5000</div>
            <div class="main_content">
              有了孩子后就想给孩子买个保险，老公之前也买过重疾险，但是感觉被坑了。后来无意间接触了骆驼规划，接待我们的顾问特别耐心，百问不厌，回答了我们很多小白的问题。他不仅帮我们分析了原有的保单，还详细问了家庭的情况，专门为我们定制了一套方案，省了5000多块钱，真是太赞了！
            </div>
          </div>
          <div class="orange_item">
            <img
              class="user_avatar"
              src="@/assets/images/version/comment2.png"
              alt=""
            />
            <div class="user_info">27岁女白领</div>
            <div class="main_title">带病投保 超级省心</div>
            <div class="main_content">
              去年母亲被诊断2型糖尿病，预计后期治疗费用高昂，突然意识到买份保险的重要性，后来尝试投保了几家保险公司的重疾险，但均被告知健康条件不满足投保要求，也逐渐放弃了希望。偶然的机会，我通过公众号找到骆驼规划，他们的顾问专家把母亲的门诊病历仔细看了几遍，最终找到了可以支持2型糖尿病加费承保的重疾产品，超级耐心。虽然保费稍微比别家贵了点，但至少有了一份保障，让人更安心一些。
            </div>
          </div>
          <div class="orange_item">
            <img
              class="user_avatar"
              src="@/assets/images/version/comment3.png"
              alt=""
            />
            <div class="user_info">32岁男蓝领</div>
            <div class="main_title">风险职业 性价比高</div>
            <div class="main_content">
              我是干工程队的，由于职业特殊，很多保险买不了，就因为这个一直拖着没买，之前也咨询过几家，评估下来价格都挺高的，动不动都上万了，就也没动力买。后来看到免费做方案的骆驼规划，1对1服务，一整个家庭评估下来保费才11000，感觉性价比很高，果断买了。
            </div>
          </div>
          <div class="orange_item">
            <img
              class="user_avatar"
              src="@/assets/images/version/comment4.png"
              alt=""
            />
            <div class="user_info">38岁全职妈妈</div>
            <div class="main_title">专业靠谱 定制方案</div>
            <div class="main_content">
              我是全职妈妈，对保险不是特别了解，生怕买错买贵。了解过几个平台，还是感觉骆驼规划平台最靠谱。不说别的，就说专业素质，一般地方都比不了。专家详细给我讲解什么是健康告知，根据我们一家人的实际情况给我们定制了一套方案，比别人家便宜了好几千，非常开心！
            </div>
          </div>
        </div>
        <v-popover
          class="my_popover"
          popoverClass="vue-popover-home"
          offset="16"
          trigger="click"
          placement="bottom"
        >
          <div class="orange_btn" @click="point('查看评价')">
            查看评价 <i class="arrow_right" />
          </div>
          <template slot="popover">
            <img
              src="@/assets/images/versionNew/qrcode_new.jpg"
              alt="骆驼讲保微信公众号二维码"
            />
            <div class="popover_text">骆驼讲保微信公众号</div>
          </template>
        </v-popover>
      </div>
      <div class="bx_container_brand">
        <div class="brand_title">
          <div class="main">
            合作品牌
          </div>
          <div class="sub">
            80+保险公司 1000+款保险产品
          </div>
        </div>

        <div class="brand_container">
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="obj in brands" :key="obj.key">
              <div class="brand_swiper_container">
                <img
                  :class="['brand_item', (index + 1) % 5 == 0 ? 'mr0' : '']"
                  v-for="(item, index) in obj.values"
                  :key="item.url"
                  :src="item.url"
                  :alt="item.name"
                />
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
    <tools :type="pageType" />
    <Footer :type="pageType" />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Tools from "@/components/absoluteTools";
import SolutionTable from "@/components/SolutionTable.vue";
import { brands } from "@/config/index";
export default {
  layout: "baseLayout",
  name: "Home",
  metaInfo() {
    return {
      title: "骆驼规划官网-润安国际保险-专业保险规划机构，省心省钱买对保险",
      keywords: "骆驼规划,保险方案,保险评测,保险理赔",
      description:
        "骆驼规划是一家专业中立的第三方保险规划平台，致力于让普通家庭也能享受到量身定制的保险规划服务，提供包括重疾险、医疗险、儿童险、寿险、意外险等在内的保险方案定制、风险评测、理赔协助、保险科普、保险评测等服务。"
    };
  },
  components: {
    Header,
    Footer,
    Tools,
    SolutionTable
  },
  data() {
    return {
      brands,
      pageType: 1,
      news: [
        {
          title: "新华社客户端",
          content:
            "骆驼规划创立初衷正是为了让更多的普通家庭也能得到中立、客观的保险咨询服务，规划好用户的每一分保费，为用户筑力一道预防风险的“铜墙铁壁”，让保障规划不再是少数人的专属。"
        },
        {
          title: "凤凰网",
          content:
            "保险选购是件非常专业化的事情，不仅条款复杂、繁琐，投保还会涉及医学、法律、金融等多方面的知识。大部分普通用户，很难对保险全面了解。为了解决这一难点，骆驼规划配置专家为每位用户提供在线1对1服务，并依托大数据、云计算和人工智能帮助客户科学配置保障方案。"
        }
      ],
      title: "",
      keywords: "",
      description: "",
      url: "",
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        // slidesPerGroup: 3,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        }
      }
    };
  },
  methods: {
    point(name) {
      const sensorData = {
        url: window.location.href,
        param1: name,
        tgt_name: "PC官网_首页",
        tgt_event_id: "bxWeb_home_menu",
        page: "PC官网_首页"
      };
      this.$point("h5_clk", sensorData);
    }
  }
};
</script>

<style lang="scss">
@import "@/css/class.scss";
@import "@/css/version.scss";
</style>
